








import Vue from "vue";
import AppHeading from "@/components/AppHeading.vue";
import MyTeamsForm from "@/components/MyTeams/MyTeamsForm.vue";
import { TeamsActionTypes, TeamsState, namespaceTeams } from "@/store/teams";

export default Vue.extend({
  name: "myTeamsNew",
  components: {
    MyTeamsForm
  },
  methods: {
    submitHandler: async function() {
      await this.$store.dispatch(`${namespaceTeams}/${TeamsActionTypes.CreateNewTeam}`);
    }
  }
});
